import { ComparisonObject } from "./comparison-data-service";

function dv<T>(value: T, fieldName: string) {
  return {
    value,
    nativeValue: value,
    formattedValue: String(value),
    originalFieldName: fieldName,
  };
}

export const mockRawComparisonObjects: ComparisonObject[] = [
  {
    name: dv("Kruisherensteenweg 16", "name"),
    type: dv("Objecten", "type"),
    value: dv("$ 320.000 - $ 4.200/m2", "value"),
    characteristics: dv(
      [
        {
          Groep_woningkermerken: {
            Correction: 1.057792254207242,
            Formatted_name: "Woningkermerken",
            Attributes: [
              { name: "Subtype", value: "Vrijstaand regulier" },
              { name: "Gebouwsoort generiek", value: null },
              { name: "Bouwstijl", value: null },
              { name: "Gebouwsoort specifiek", value: null },
              { name: "Gebouwsubtype", value: null },
              { name: "Bouwjaar", value: "1956" },
              { name: "BAG pand id", value: null },
              { name: "Aantal woningen in BAG pand", value: null },
              { name: "Gebouwhoogte", value: null },
              { name: "Oppervlakte plat dak", value: null },
              { name: "Oppervlakte schuin dak", value: null },
              { name: "Ratio schuin plat dak", value: null },
              { name: "Afwerking", value: "6.3956" },
              { name: "Uitstraling", value: "6.96875" },
            ],
          },
          Groep_oppervlakte: {
            Correction: 0.7897056498447119,
            Formatted_name: "Oppervlakte en indeling",
            Attributes: [
              { name: "Oppervlakte wonen", value: "202.754" },
              {
                name: "Oppervlakte overige inpandige ruimte",
                value: "11.5156",
              },
              { name: "Oppervlakte externe bergruimte", value: null },
              { name: "Aantal kamers", value: null },
              { name: "Woningtype", value: "Eengezinswoning" },
              { name: "Aantal garages", value: null },
              { name: "Aantal parkeerplaatsen", value: null },
            ],
          },
          Groep_buitenruimte: {
            Correction: 1.095725896321166,
            Formatted_name: "Buitenruimte",
            Attributes: [
              { name: "Kavel", value: "657" },
              { name: "Buitenruimte", value: null },
              { name: "Liggin tuin", value: null },
            ],
          },
          Groep_energie_en_woonlasten: {
            Correction: 0.9794735932078086,
            Formatted_name: "Energie en woonlasten",
            Attributes: [
              { name: "Primair fossiele energiegebruik", value: null },
              { name: "Percentage hernieuwbare energie", value: null },
            ],
          },
          Groep_locatie: {
            Correction: 1.872842944407889,
            Formatted_name: "Locatie",
            Attributes: [
              { name: "Corop", value: null },
              { name: "Gemeente", value: "Haarlem" },
              { name: "Provincie", value: null },
              { name: "Woonplaats", value: "Haarlem" },
              { name: "Buurt", value: "Zuiderhout" },
              { name: "Wijk", value: "Haarlemmerhoutkwartier" },
              { name: "Gemiddelde boomdichtheid buurt", value: null },
              { name: "Gemiddelde struikdichtheid buurt", value: null },
              { name: "Gemiddelde ligging aan water buurt", value: null },
              { name: "Gemiddelde geluid wegverkeer buurt", value: null },
              { name: "Gemiddelde fysieke omgeving buurt", value: null },
              {
                name: "Gemiddelde overlast en onveiligheid buurt",
                value: null,
              },
              { name: "Gemiddelde sociale samenhang buurt", value: null },
              { name: "Gemiddelde voorzieningsniveau buurt", value: null },
              { name: "Gemiddelde woningvoorraad buurt", value: null },
            ],
          },
          Groep_directe_omgeving: {
            Correction: 1.049811883906497,
            Formatted_name: "Directe omgeving",
            Attributes: [
              { name: "Breedtegraad", value: "52.3627" },
              { name: "Lengtegraad", value: "4.6226" },
              { name: "Boomdichtheid", value: null },
              { name: "Struikdichtheid", value: null },
              { name: "Ligging aan water", value: null },
              { name: "Geluid wegverkeer", value: null },
              { name: "Fysieke omgeving", value: null },
              { name: "Overlast en onveiligheid", value: null },
              { name: "Sociale samenhang", value: null },
              { name: "Voorzieningsniveau", value: null },
              { name: "Woningvoorraad", value: null },
              { name: "Gemeentetype", value: null },
            ],
          },
          Groep_rest: {
            Correction: 0.9835036592080543,
            Formatted_name: "Rest",
            Attributes: [{ name: null, value: null }],
          },
          Groep_totaal: {
            Correction: 1.726428247143121,
            Formatted_name: "Totaal",
            Attributes: [{ name: null, value: null }],
          },
        },
      ],
      "characteristics",
    ),
  },
  {
    name: dv("Leidsevaart 204", "name"),
    type: dv("Objecten", "type"),
    value: dv("$ 298.000 - $ 4.200/m2", "value"),
    characteristics: dv(
      [
        {
          Groep_woningkermerken: {
            Correction: 1.023,
            Formatted_name: "Woningkermerken",
            Attributes: [
              { name: "Subtype", value: "Hoekwoning regulier" },
              { name: "Gebouwsoort generiek", value: null },
              { name: "Bouwstijl", value: null },
              { name: "Gebouwsoort specifiek", value: null },
              { name: "Gebouwsubtype", value: null },
              { name: "Bouwjaar", value: "1971" },
              { name: "BAG pand id", value: null },
              { name: "Aantal woningen in BAG pand", value: null },
              { name: "Gebouwhoogte", value: null },
              { name: "Oppervlakte plat dak", value: null },
              { name: "Oppervlakte schuin dak", value: null },
              { name: "Ratio schuin plat dak", value: null },
              { name: "Afwerking", value: "6.10" },
              { name: "Uitstraling", value: "6.50" },
            ],
          },
          Groep_oppervlakte: {
            Correction: 0.854,
            Formatted_name: "Oppervlakte en indeling",
            Attributes: [
              { name: "Oppervlakte wonen", value: "145" },
              { name: "Oppervlakte overige inpandige ruimte", value: "8" },
              { name: "Oppervlakte externe bergruimte", value: null },
              { name: "Aantal kamers", value: null },
              { name: "Woningtype", value: "Eengezinswoning" },
              { name: "Aantal garages", value: null },
              { name: "Aantal parkeerplaatsen", value: null },
            ],
          },
          Groep_buitenruimte: {
            Correction: 1.041,
            Formatted_name: "Buitenruimte",
            Attributes: [
              { name: "Kavel", value: "310" },
              { name: "Buitenruimte", value: null },
              { name: "Liggin tuin", value: null },
            ],
          },
          Groep_energie_en_woonlasten: {
            Correction: 0.988,
            Formatted_name: "Energie en woonlasten",
            Attributes: [
              { name: "Primair fossiele energiegebruik", value: null },
              { name: "Percentage hernieuwbare energie", value: null },
            ],
          },
          Groep_locatie: {
            Correction: 1.812,
            Formatted_name: "Locatie",
            Attributes: [
              { name: "Corop", value: null },
              { name: "Gemeente", value: "Haarlem" },
              { name: "Provincie", value: null },
              { name: "Woonplaats", value: "Haarlem" },
              { name: "Buurt", value: "Leidsebuurt Noord" },
              { name: "Wijk", value: "Leidsebuurt" },
              { name: "Gemiddelde boomdichtheid buurt", value: null },
              { name: "Gemiddelde struikdichtheid buurt", value: null },
              { name: "Gemiddelde ligging aan water buurt", value: null },
              { name: "Gemiddelde geluid wegverkeer buurt", value: null },
              { name: "Gemiddelde fysieke omgeving buurt", value: null },
              {
                name: "Gemiddelde overlast en onveiligheid buurt",
                value: null,
              },
              { name: "Gemiddelde sociale samenhang buurt", value: null },
              { name: "Gemiddelde voorzieningsniveau buurt", value: null },
              { name: "Gemiddelde woningvoorraad buurt", value: null },
            ],
          },
          Groep_directe_omgeving: {
            Correction: 1.027,
            Formatted_name: "Directe omgeving",
            Attributes: [
              { name: "Breedtegraad", value: "52.3741" },
              { name: "Lengtegraad", value: "4.6153" },
              { name: "Boomdichtheid", value: null },
              { name: "Struikdichtheid", value: null },
              { name: "Ligging aan water", value: null },
              { name: "Geluid wegverkeer", value: null },
              { name: "Fysieke omgeving", value: null },
              { name: "Overlast en onveiligheid", value: null },
              { name: "Sociale samenhang", value: null },
              { name: "Voorzieningsniveau", value: null },
              { name: "Woningvoorraad", value: null },
              { name: "Gemeentetype", value: null },
            ],
          },
          Groep_rest: {
            Correction: 0.974,
            Formatted_name: "Rest",
            Attributes: [{ name: null, value: null }],
          },
          Groep_totaal: {
            Correction: 1.589,
            Formatted_name: "Totaal",
            Attributes: [{ name: null, value: null }],
          },
        },
      ],
      "characteristics",
    ),
  },
  {
    name: dv("Kruisherensteenweg 18", "name"),
    type: dv("Referenties", "type"),
    value: dv("$ 341.500 - $ 4.200/m2", "value"),
    characteristics: dv(
      [
        {
          Groep_woningkermerken: {
            Correction: 1.032,
            Formatted_name: "Woningkermerken",
            Attributes: [
              { name: "Subtype", value: "Vrijstaand regulier" },
              { name: "Gebouwsoort generiek", value: null },
              { name: "Bouwstijl", value: null },
              { name: "Gebouwsoort specifiek", value: null },
              { name: "Gebouwsubtype", value: null },
              { name: "Bouwjaar", value: "1958" },
              { name: "BAG pand id", value: null },
              { name: "Aantal woningen in BAG pand", value: null },
              { name: "Gebouwhoogte", value: null },
              { name: "Oppervlakte plat dak", value: null },
              { name: "Oppervlakte schuin dak", value: null },
              { name: "Ratio schuin plat dak", value: null },
              { name: "Afwerking", value: "6.40" },
              { name: "Uitstraling", value: "6.80" },
            ],
          },
          Groep_oppervlakte: {
            Correction: 0.812,
            Formatted_name: "Oppervlakte en indeling",
            Attributes: [
              { name: "Oppervlakte wonen", value: "205" },
              { name: "Oppervlakte overige inpandige ruimte", value: "12" },
              { name: "Oppervlakte externe bergruimte", value: null },
              { name: "Aantal kamers", value: null },
              { name: "Woningtype", value: "Eengezinswoning" },
              { name: "Aantal garages", value: null },
              { name: "Aantal parkeerplaatsen", value: null },
            ],
          },
          Groep_buitenruimte: {
            Correction: 1.072,
            Formatted_name: "Buitenruimte",
            Attributes: [
              { name: "Kavel", value: "640" },
              { name: "Buitenruimte", value: null },
              { name: "Liggin tuin", value: null },
            ],
          },
          Groep_energie_en_woonlasten: {
            Correction: 0.994,
            Formatted_name: "Energie en woonlasten",
            Attributes: [
              { name: "Primair fossiele energiegebruik", value: null },
              { name: "Percentage hernieuwbare energie", value: null },
            ],
          },
          Groep_locatie: {
            Correction: 1.841,
            Formatted_name: "Locatie",
            Attributes: [
              { name: "Corop", value: null },
              { name: "Gemeente", value: "Haarlem" },
              { name: "Provincie", value: null },
              { name: "Woonplaats", value: "Haarlem" },
              { name: "Buurt", value: "Zuiderhout" },
              { name: "Wijk", value: "Haarlemmerhoutkwartier" },
              { name: "Gemiddelde boomdichtheid buurt", value: null },
              { name: "Gemiddelde struikdichtheid buurt", value: null },
              { name: "Gemiddelde ligging aan water buurt", value: null },
              { name: "Gemiddelde geluid wegverkeer buurt", value: null },
              { name: "Gemiddelde fysieke omgeving buurt", value: null },
              {
                name: "Gemiddelde overlast en onveiligheid buurt",
                value: null,
              },
              { name: "Gemiddelde sociale samenhang buurt", value: null },
              { name: "Gemiddelde voorzieningsniveau buurt", value: null },
              { name: "Gemiddelde woningvoorraad buurt", value: null },
            ],
          },
          Groep_directe_omgeving: {
            Correction: 1.038,
            Formatted_name: "Directe omgeving",
            Attributes: [
              { name: "Breedtegraad", value: "52.3630" },
              { name: "Lengtegraad", value: "4.6229" },
              { name: "Boomdichtheid", value: null },
              { name: "Struikdichtheid", value: null },
              { name: "Ligging aan water", value: null },
              { name: "Geluid wegverkeer", value: null },
              { name: "Fysieke omgeving", value: null },
              { name: "Overlast en onveiligheid", value: null },
              { name: "Sociale samenhang", value: null },
              { name: "Voorzieningsniveau", value: null },
              { name: "Woningvoorraad", value: null },
              { name: "Gemeentetype", value: null },
            ],
          },
          Groep_rest: {
            Correction: 0.971,
            Formatted_name: "Rest",
            Attributes: [{ name: null, value: null }],
          },
          Groep_totaal: {
            Correction: 1.698,
            Formatted_name: "Totaal",
            Attributes: [{ name: null, value: null }],
          },
        },
      ],
      "characteristics",
    ),
  },
  {
    name: dv("Kruisherensteenweg 16", "name"),
    type: dv("Referenties", "type"),
    value: dv("$ 385.000 - $ 4.200/m2", "value"),
    characteristics: dv(
      [
        {
          Groep_woningkermerken: {
            Correction: 1.081,
            Formatted_name: "Woningkermerken",
            Attributes: [
              { name: "Subtype", value: "Vrijstaand regulier" },
              { name: "Gebouwsoort generiek", value: null },
              { name: "Bouwstijl", value: null },
              { name: "Gebouwsoort specifiek", value: null },
              { name: "Gebouwsubtype", value: null },
              { name: "Bouwjaar", value: "1962" },
              { name: "BAG pand id", value: null },
              { name: "Aantal woningen in BAG pand", value: null },
              { name: "Gebouwhoogte", value: null },
              { name: "Oppervlakte plat dak", value: null },
              { name: "Oppervlakte schuin dak", value: null },
              { name: "Ratio schuin plat dak", value: null },
              { name: "Afwerking", value: "6.60" },
              { name: "Uitstraling", value: "7.10" },
            ],
          },
          Groep_oppervlakte: {
            Correction: 0.768,
            Formatted_name: "Oppervlakte en indeling",
            Attributes: [
              { name: "Oppervlakte wonen", value: "216" },
              { name: "Oppervlakte overige inpandige ruimte", value: "15" },
              { name: "Oppervlakte externe bergruimte", value: null },
              { name: "Aantal kamers", value: null },
              { name: "Woningtype", value: "Eengezinswoning" },
              { name: "Aantal garages", value: null },
              { name: "Aantal parkeerplaatsen", value: null },
            ],
          },
          Groep_buitenruimte: {
            Correction: 1.118,
            Formatted_name: "Buitenruimte",
            Attributes: [
              { name: "Kavel", value: "710" },
              { name: "Buitenruimte", value: null },
              { name: "Liggin tuin", value: null },
            ],
          },
          Groep_energie_en_woonlasten: {
            Correction: 0.963,
            Formatted_name: "Energie en woonlasten",
            Attributes: [
              { name: "Primair fossiele energiegebruik", value: null },
              { name: "Percentage hernieuwbare energie", value: null },
            ],
          },
          Groep_locatie: {
            Correction: 1.905,
            Formatted_name: "Locatie",
            Attributes: [
              { name: "Corop", value: null },
              { name: "Gemeente", value: "Haarlem" },
              { name: "Provincie", value: null },
              { name: "Woonplaats", value: "Haarlem" },
              { name: "Buurt", value: "Parkwijk" },
              { name: "Wijk", value: "Haarlemmerhoutkwartier" },
              { name: "Gemiddelde boomdichtheid buurt", value: null },
              { name: "Gemiddelde struikdichtheid buurt", value: null },
              { name: "Gemiddelde ligging aan water buurt", value: null },
              { name: "Gemiddelde geluid wegverkeer buurt", value: null },
              { name: "Gemiddelde fysieke omgeving buurt", value: null },
              {
                name: "Gemiddelde overlast en onveiligheid buurt",
                value: null,
              },
              { name: "Gemiddelde sociale samenhang buurt", value: null },
              { name: "Gemiddelde voorzieningsniveau buurt", value: null },
              { name: "Gemiddelde woningvoorraad buurt", value: null },
            ],
          },
          Groep_directe_omgeving: {
            Correction: 1.063,
            Formatted_name: "Directe omgeving",
            Attributes: [
              { name: "Breedtegraad", value: "52.3618" },
              { name: "Lengtegraad", value: "4.6218" },
              { name: "Boomdichtheid", value: null },
              { name: "Struikdichtheid", value: null },
              { name: "Ligging aan water", value: null },
              { name: "Geluid wegverkeer", value: null },
              { name: "Fysieke omgeving", value: null },
              { name: "Overlast en onveiligheid", value: null },
              { name: "Sociale samenhang", value: null },
              { name: "Voorzieningsniveau", value: null },
              { name: "Woningvoorraad", value: null },
              { name: "Gemeentetype", value: null },
            ],
          },
          Groep_rest: {
            Correction: 0.996,
            Formatted_name: "Rest",
            Attributes: [{ name: null, value: null }],
          },
          Groep_totaal: {
            Correction: 1.754,
            Formatted_name: "Totaal",
            Attributes: [{ name: null, value: null }],
          },
        },
      ],
      "characteristics",
    ),
  },
];
